/* دوّر واربح — prize wheel (sections/jy-wheel.liquid).
   The worker picks the slot (/wheel/spin); this file animates the wheel to it,
   then claims the prize with the phone (WhatsApp code, same session as the
   account portal: localStorage jy_portal_token). */
(function () {
  'use strict';
  /* The dialog lives in a <template> and its stylesheet is fetched on first
     open, so pages where nobody opens the wheel only pay for this file and
     the small inline button styles. */
  var tpl = document.querySelector('[data-jy-wheel-tpl]');
  if (!tpl || !window.JY_COD_ENDPOINT) return;
  var api = null;
  var waiting = false;
  function loadCss(done) {
    var href = tpl.getAttribute('data-css');
    var l = document.createElement('link');
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      done();
    }
    l.rel = 'stylesheet';
    l.href = href;
    l.onload = go;
    l.onerror = go;
    setTimeout(go, 3000);
    document.head.appendChild(l);
  }
  function withWheel(fn) {
    if (api) return fn(api);
    if (waiting) return;
    waiting = true;
    loadCss(function () {
      api = mount();
      waiting = false;
      fn(api);
    });
  }
  function openWheel() {
    withWheel(function (w) { w.open(); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-jy-wheel-open], a[href$="#wheel"], a[href$="?wheel=1"]');
    if (!a) return;
    e.preventDefault();
    openWheel();
  });
  var fab = document.querySelector('[data-jy-wheel-fab]');
  if (fab) fab.hidden = false;
  if (location.hash === '#wheel' || /[?&]wheel=1\b/.test(location.search)) openWheel();
  window.addEventListener('hashchange', function () {
    if (location.hash === '#wheel') openWheel();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.contains(tpl)) openWheel();
  });
  /* warm the stylesheet once the page is idle, so the first open is instant */
  (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(function () {
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'style';
    l.href = tpl.getAttribute('data-css');
    document.head.appendChild(l);
  });

  function mount() {
    document.body.appendChild(tpl.content.cloneNode(true));
    var root = document.querySelector('[data-jy-wheel]');
    var base = String(window.JY_COD_ENDPOINT).replace(/\/+$/, '');
    var T = {};
    try {
      T = JSON.parse(document.querySelector('[data-jy-wheel-i18n]').textContent);
    } catch (e) {
      /* keep the markup's own copy */
    }
    var TOKEN_KEY = 'jy_portal_token';
    var PHONE_KEY = 'jy_portal_phone';
    var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var PLAT = window.JY_IS_APP === true ? 'app' : 'web';
    var stage = root.querySelector('.jyw__stage');
    var face = root.querySelector('[data-jyw-face]');
    var pointer = root.querySelector('[data-jyw-pointer]');
    var spinBtns = root.querySelectorAll('[data-jyw-spin]');
    var ctaBtn = root.querySelector('.jyw__cta[data-jyw-spin]');
    var hubBtn = root.querySelector('.jyw__hub');
    var msgEl = root.querySelector('[data-jyw-msg]');
    var chip = root.querySelector('[data-jyw-chip]');
    var soundBtn = root.querySelector('[data-jyw-sound]');

    function t(key, vars) {
      var s = T[key] || '';
      if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
      return s;
    }
    function token() {
      try { return localStorage.getItem(TOKEN_KEY) || ''; } catch (e) { return ''; }
    }
    function did() {
      try {
        var d = localStorage.getItem('jy_wheel_did');
        if (!d) {
          d = 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
          localStorage.setItem('jy_wheel_did', d);
        }
        return d;
      } catch (e) {
        return 'n' + Math.random().toString(36).slice(2, 12);
      }
    }
    function post(path, body) {
      /* a hung request must not leave the wheel stuck in "spinning" */
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, 15000) : null;
      return fetch(base + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: ctl ? ctl.signal : undefined,
      }).then(function (r) {
        clearTimeout(timer);
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || j.ok === false) throw new Error(j.error || 'err');
          return j;
        });
      });
    }
    function track(step) {
      try {
        if (window.gtag) window.gtag('event', 'jy_' + step, { jy_platform: PLAT });
        if (window.clarity) window.clarity('event', 'jy_' + step);
        var body = JSON.stringify({ e: step, p: PLAT, l: (document.documentElement.lang || 'fr').slice(0, 2) });
        if (navigator.sendBeacon) navigator.sendBeacon(base + '/t', new Blob([body], { type: 'text/plain' }));
        else fetch(base + '/t', { method: 'POST', body: body, keepalive: true });
      } catch (e) {
        /* tracking never blocks the game */
      }
    }

    /* ---------- prize copy ---------- */
    var slots = [
      { k: 0, mad: 20, min: 150 }, { k: 1, mad: 50, min: 300 }, { k: 2, mad: 25, min: 0, kind: 'ship' },
      { k: 3, mad: 100, min: 500 }, { k: 4, mad: 300, min: 0, kind: 'big' }, { k: 5, mad: 200, min: 800 },
    ];
    var days = 7;
    function slot(k) {
      for (var i = 0; i < slots.length; i++) if (slots[i].k === k) return slots[i];
      return slots[0];
    }
    function prizeTitle(p) {
      if (p.kind === 'ship') return t('ship');
      if (p.kind === 'big') return t('big');
      return p.mad + ' ' + t('dh');
    }
    function prizeCond(p) {
      var c = p.min > 0 ? t('min', { m: p.min }) : t('nomin');
      if (p.kind === 'ship') c = p.mad + ' ' + t('dh') + ' · ' + c;
      return c;
    }

    /* ---------- open / close ---------- */
    var lastFocus = null;
    var stateLoaded = false;
    var fontLoaded = false;
    function open() {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      if (!fontLoaded) {
        fontLoaded = true;
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = 'https://fonts.googleapis.com/css2?family=Lalezar&display=swap';
        document.head.appendChild(l);
      }
      root.hidden = false;
      document.documentElement.classList.add('jyw-lock');
      stage.focus();
      track('wheel_open');
      loadState();
    }
    function close() {
      if (root.hidden || phase === 'spinning') return;
      root.hidden = true;
      document.documentElement.classList.remove('jyw-lock');
      if (location.hash === '#wheel' || /[?&]wheel=1\b/.test(location.search)) {
        var q = location.search.replace(/([?&])wheel=1\b&?/, '$1').replace(/[?&]$/, '');
        try { history.replaceState(null, '', location.pathname + q); } catch (e) { /* noop */ }
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.querySelectorAll('[data-jyw-close]').forEach(function (b) { b.addEventListener('click', close); });
    root.addEventListener('click', function (e) {
      if (e.target === root) close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!screenEl('odds').hidden) return showScreen(null);
        return close();
      }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        stage.querySelectorAll('button, a[href], input'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    /* ---------- screens ---------- */
    function screenEl(name) { return root.querySelector('[data-jyw-screen="' + name + '"]'); }
    function showScreen(name) {
      root.querySelectorAll('[data-jyw-screen]').forEach(function (s) {
        s.hidden = s.getAttribute('data-jyw-screen') !== name;
      });
      var s = name && screenEl(name);
      if (s) {
        var f = s.querySelector('input:not([type=hidden]), button, a[href]');
        if (f) setTimeout(function () { f.focus(); }, 60);
      }
    }
    function say(text) {
      msgEl.textContent = text || '';
      msgEl.hidden = !text;
    }
    function setSpins(n) {
      chip.textContent = n === 1 ? t('spins1') : n > 1 ? t('spinsN', { n: n }) : t('spins0');
    }

    /* ---------- state ---------- */
    var pending = null; /* {sid, k} — spun, not yet claimed */
    var activePrizes = [];
    function loadState() {
      if (stateLoaded) return;
      post('/wheel/state', { token: token() || undefined, did: did() })
        .then(function (j) {
          stateLoaded = true;
          if (j.slots && j.slots.length) slots = j.slots;
          if (j.days) days = j.days;
          renderOdds();
          activePrizes = j.prizes || [];
          if (typeof j.spins === 'number') {
            setSpins(j.spins);
            if (j.spins <= 0) return showNoSpin();
          }
          if (j.pending && phase === 'idle' && !pending) {
            pending = j.pending;
            landAt(j.pending.k, true);
            showTicket(slot(j.pending.k), false);
          }
        })
        .catch(function () {
          renderOdds();
        });
    }
    function renderOdds() {
      var tb = root.querySelector('[data-jyw-odds]');
      if (!tb) return;
      var order = slots.slice().sort(function (a, b) { return b.w - a.w; });
      tb.innerHTML = '';
      order.forEach(function (s) {
        if (s.w == null) return;
        var tr = document.createElement('tr');
        [prizeTitle(s), s.min > 0 ? s.min + ' ' + t('dh') : t('none'), (Math.round(s.w * 10) / 10) + '%'].forEach(function (v) {
          var td = document.createElement('td');
          td.textContent = v;
          tr.appendChild(td);
        });
        tb.appendChild(tr);
      });
    }
    root.querySelector('[data-jyw-odds-open]').addEventListener('click', function () { showScreen('odds'); });
    root.querySelector('[data-jyw-odds-close]').addEventListener('click', function () { showScreen(null); });

    /* ---------- bulbs ---------- */
    (function () {
      var box = root.querySelector('[data-jyw-bulbs]');
      var html = '';
      for (var i = 0; i < 20; i++) {
        var a = (i * 18 * Math.PI) / 180;
        html += '<i style="left:' + (50 + 47.06 * Math.sin(a)).toFixed(2) + '%;top:' + (50 - 47.06 * Math.cos(a)).toFixed(2) + '%"></i>';
      }
      box.innerHTML = html;
    })();
    function bulbSpeed(s) { root.style.setProperty('--jyw-bd', s); }

    /* ---------- sound ---------- */
    var soundOn = false;
    var ac = null;
    soundBtn.addEventListener('click', function () {
      soundOn = !soundOn;
      soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', soundOn ? t('soundOn') : t('soundOff'));
    });
    function beep(f, d, g) {
      if (!soundOn) return;
      try {
        ac = ac || new (window.AudioContext || window.webkitAudioContext)();
        var o = ac.createOscillator();
        var v = ac.createGain();
        o.type = 'triangle';
        o.frequency.value = f;
        v.gain.setValueAtTime(g, ac.currentTime);
        v.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + d);
        o.connect(v);
        v.connect(ac.destination);
        o.start();
        o.stop(ac.currentTime + d);
      } catch (e) {
        /* no audio */
      }
    }
    function buzz(p) {
      try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) { /* noop */ }
    }

    /* ---------- spin ---------- */
    var phase = 'idle';
    var rot = 0;
    function setRot(a, kick) {
      face.style.transform = 'rotate(' + a.toFixed(2) + 'deg)';
      pointer.style.transform = 'rotate(' + (-kick * 26).toFixed(1) + 'deg)';
    }
    function setBusy(b) {
      spinBtns.forEach(function (x) { x.disabled = b; });
      ctaBtn.textContent = b ? t('spinning') : t('spin');
    }
    function landAt(k, instant) {
      var jitter = Math.random() * 34 - 17;
      var target = (((360 - k * 60 + jitter) % 360) + 360) % 360;
      if (instant) {
        rot = target;
        setRot(rot, 0);
        root.classList.add('is-landed');
      }
      return target;
    }
    function animateTo(k, done) {
      var start = rot;
      var target = landAt(k, false);
      var D = (((target - (start % 360)) + 360) % 360) + 2160;
      if (REDUCED) {
        rot = start + D;
        setRot(rot, 0);
        return done();
      }
      var over = 6;
      var dur = 5600;
      var t0 = null;
      var seg = Math.floor((start + 30) / 60);
      var kick = 0;
      bulbSpeed('.18s');
      function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / dur);
        var a;
        if (p < 0.88) {
          a = start + (D + over) * (1 - Math.pow(1 - p / 0.88, 4));
        } else {
          var u = (p - 0.88) / 0.12;
          var e = u < 0.5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
          a = start + D + over - over * e;
        }
        var s = Math.floor((a + 30) / 60);
        if (s !== seg) {
          seg = s;
          kick = 1;
          beep(1900, 0.03, 0.06);
          buzz(6);
        } else {
          kick *= 0.8;
        }
        rot = a;
        setRot(a, kick);
        if (p < 1) requestAnimationFrame(step);
        else done();
      }
      requestAnimationFrame(step);
    }
    function spin() {
      if (phase !== 'idle') return;
      if (pending) return showTicket(slot(pending.k), false);
      phase = 'spinning';
      setBusy(true);
      say('');
      root.classList.remove('is-landed');
      var tok = token();
      post('/wheel/spin', { did: did(), token: tok || undefined })
        .then(function (j) {
          track('wheel_spin');
          var claimed = j.claimed === true;
          if (claimed) {
            activePrizes = [{ k: j.k, mad: j.mad, min: j.min, exp: j.exp }].concat(activePrizes);
          } else {
            pending = { sid: j.sid, k: j.k };
          }
          animateTo(j.k, function () {
            phase = 'landed';
            root.classList.add('is-landed');
            bulbSpeed('.3s');
            beep(660, 0.15, 0.12);
            setTimeout(function () { beep(880, 0.15, 0.12); }, 120);
            setTimeout(function () { beep(1320, 0.4, 0.12); }, 240);
            buzz([30, 40, 60]);
            track('wheel_win');
            setTimeout(function () {
              showTicket(slot(j.k), claimed);
              phase = 'idle';
              setBusy(false);
              bulbSpeed('1.2s');
            }, REDUCED ? 200 : 1100);
          });
        })
        .catch(function (e) {
          phase = 'idle';
          setBusy(false);
          var code = e.message;
          if (code === 'no_spins') return showNoSpin();
          if (code === 'login') {
            say(t('login'));
            return showClaim(null);
          }
          say(t('err_' + code) || t('err'));
        });
    }
    spinBtns.forEach(function (b) { b.addEventListener('click', spin); });
    /* fling the wheel: a drag longer than 40px spins it */
    (function () {
      var box = root.querySelector('[data-jyw-drag]');
      var sx = null;
      var sy = null;
      box.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
      box.addEventListener('pointerup', function (e) {
        if (sx === null) return;
        var d = Math.hypot(e.clientX - sx, e.clientY - sy);
        sx = null;
        if (d > 40) spin();
      });
    })();

    /* ---------- ticket ---------- */
    var shown = null; /* slot on the ticket */
    var shownClaimed = false;
    function confetti() {
      var c = root.querySelector('[data-jyw-confetti]');
      if (REDUCED) return;
      var cols = ['#f6d27a', '#c4301c', '#fff3dc', '#e0a93a', '#17843f', '#ffffff'];
      var h = '';
      for (var i = 0; i < 24; i++) {
        h += '<i style="left:' + (2 + i * 4.1).toFixed(1) + '%;background:' + cols[i % cols.length] + ';animation-delay:' + (((i * 7) % 10) * 0.08).toFixed(2) + 's"></i>';
      }
      c.innerHTML = h;
    }
    function showTicket(p, claimed) {
      shown = p;
      shownClaimed = claimed;
      var big = root.querySelector('[data-jyw-big]');
      var unit = root.querySelector('[data-jyw-unit]');
      if (p.kind === 'ship' || p.kind === 'big') {
        big.textContent = prizeTitle(p);
        big.classList.add('is-text');
        unit.textContent = p.kind === 'ship' ? t('shipUnit') : t('bigUnit', { m: p.mad });
      } else {
        big.textContent = p.mad;
        big.classList.remove('is-text');
        unit.textContent = t('unit');
      }
      root.querySelector('[data-jyw-cond]').textContent = prizeCond(p) + ' · ' + t('valid', { d: days });
      confetti();
      showScreen('ticket');
    }
    root.querySelector('[data-jyw-claim]').addEventListener('click', function () {
      if (shownClaimed) return showDone(shown);
      if (token() && pending) return claim(token());
      showClaim(shown);
    });

    /* ---------- claim (phone → WhatsApp code) ---------- */
    var phoneForm = root.querySelector('[data-jyw-phone-form]');
    var codeForm = root.querySelector('[data-jyw-code-form]');
    var err1 = root.querySelector('[data-jyw-err1]');
    var err2 = root.querySelector('[data-jyw-err2]');
    var phoneE164 = '';
    var verifying = false;
    function setErr(el, msg) {
      el.textContent = msg || '';
      el.hidden = !msg;
    }
    function busyForm(form, b) {
      var btn = form.querySelector('[type=submit]');
      if (btn) btn.disabled = b;
    }
    function showClaim(p) {
      var held = root.querySelector('.jyw__held');
      if (p) {
        root.querySelector('[data-jyw-chipmad]').textContent = p.kind === 'big' ? 'JY' : p.mad;
        root.querySelector('[data-jyw-held]').textContent = t('held', { p: prizeTitle(p) });
        held.hidden = false;
      } else {
        held.hidden = true;
      }
      phoneForm.hidden = false;
      codeForm.hidden = true;
      try {
        var saved = localStorage.getItem(PHONE_KEY) || '';
        var inp = phoneForm.querySelector('[name=phone]');
        if (saved && !inp.value) inp.value = saved.replace(/[^\d]/g, '').replace(/^212/, '');
      } catch (e) {
        /* noop */
      }
      showScreen('claim');
    }
    phoneForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var nat = (phoneForm.querySelector('[name=phone]').value || '').replace(/[^\d]/g, '').replace(/^212/, '').replace(/^0+/, '');
      if (!/^[567]\d{8}$/.test(nat)) return setErr(err1, t('err_invalid_phone'));
      setErr(err1, '');
      busyForm(phoneForm, true);
      phoneE164 = '+212' + nat;
      post('/otp/send', { phone: phoneE164 })
        .then(function () {
          root.querySelector('[data-jyw-sentto]').textContent = phoneE164;
          phoneForm.hidden = true;
          codeForm.hidden = false;
          var ci = codeForm.querySelector('[name=code]');
          ci.value = '';
          ci.focus();
        })
        .catch(function (er) { setErr(err1, t('err_' + er.message) || t('err')); })
        .then(function () { busyForm(phoneForm, false); });
    });
    root.querySelector('[data-jyw-back]').addEventListener('click', function () {
      codeForm.hidden = true;
      phoneForm.hidden = false;
    });
    codeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (codeForm.querySelector('[name=code]').value || '').replace(/[^\d]/g, '');
      if (code.length !== 6) return setErr(err2, t('err_wrong_code'));
      if (verifying) return;
      verifying = true;
      setErr(err2, '');
      busyForm(codeForm, true);
      post('/otp/verify', { phone: phoneE164, code: code })
        .then(function (j) {
          try {
            localStorage.setItem(TOKEN_KEY, j.token);
            localStorage.setItem(PHONE_KEY, phoneE164);
          } catch (er) {
            /* session only for this claim */
          }
          track('wheel_claim');
          if (pending) return claim(j.token);
          /* signed in from the "login" prompt: reload spins and go back to the wheel */
          stateLoaded = false;
          showScreen(null);
          loadState();
        })
        .catch(function (er) { setErr(err2, t('err_' + er.message) || t('err')); })
        .then(function () {
          verifying = false;
          busyForm(codeForm, false);
        });
    });
    codeForm.querySelector('[name=code]').addEventListener('input', function (e) {
      if (e.target.value.replace(/[^\d]/g, '').length === 6) codeForm.requestSubmit ? codeForm.requestSubmit() : null;
    });
    function claim(tok) {
      return post('/wheel/claim', { token: tok, sid: pending.sid, did: did() })
        .then(function (j) {
          pending = null;
          activePrizes = [{ k: j.k, mad: j.mad, min: j.min, exp: j.exp }].concat(activePrizes);
          showDone(slot(j.k));
        })
        .catch(function (er) {
          if (er.message === 'no_spins' || er.message === 'expired') {
            pending = null;
            return showNoSpin();
          }
          setErr(err2, t('err'));
          showClaim(shown);
        });
    }

    /* ---------- done ---------- */
    function showDone(p) {
      track('wheel_done');
      try { document.dispatchEvent(new CustomEvent('jy:wheel:won')); } catch (e) { /* old browsers */ }
      setSpins(0);
      root.querySelector('[data-jyw-done-h]').textContent = t('done', { p: prizeTitle(p) });
      root.querySelector('[data-jyw-days]').textContent = days;
      root.querySelector('[data-jyw-cond2]').textContent = prizeCond(p);
      var fly = root.querySelector('[data-jyw-flycoin]');
      fly.style.animation = 'none';
      void fly.offsetWidth;
      fly.style.animation = '';
      showScreen('done');
      if (p.min > 0) progress(p);
    }
    function progress(p) {
      var box = root.querySelector('[data-jyw-progress]');
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var have = Math.round((c.original_total_price || c.total_price || 0) / 100);
          root.querySelector('[data-jyw-cartx]').textContent = have + ' / ' + p.min + ' ' + t('dh');
          root.querySelector('[data-jyw-gap]').textContent =
            have >= p.min ? t('gapOk') : t('gap', { g: p.min - have, p: prizeTitle(p) });
          box.hidden = false;
          var bar = root.querySelector('[data-jyw-bar]');
          bar.style.width = '0';
          requestAnimationFrame(function () {
            bar.style.width = Math.min(100, Math.round((have / p.min) * 100)) + '%';
          });
        })
        .catch(function () { box.hidden = true; });
    }
    root.querySelector('[data-jyw-shop]').addEventListener('click', function () { track('wheel_shop'); });

    /* ---------- no spins left ---------- */
    function showNoSpin() {
      track('wheel_nospin');
      setSpins(0);
      var a = activePrizes[0];
      var box = root.querySelector('[data-jyw-active]');
      if (a) {
        var p = { k: a.k, mad: a.mad, min: a.min, kind: slot(a.k).kind };
        var left = Math.max(1, Math.ceil((a.exp - Date.now()) / 86400000));
        root.querySelector('[data-jyw-active-mad]').textContent = p.kind === 'big' ? 'JY' : p.mad;
        root.querySelector('[data-jyw-active-h]').textContent = t('active', { p: prizeTitle(p) });
        root.querySelector('[data-jyw-active-s]').textContent = t('activeS', { c: prizeCond(p), d: left });
        box.hidden = false;
      } else {
        box.hidden = true;
      }
      showScreen('nospin');
    }

    return { open: open };
  }
})();
